import axios from "axios";

import { config } from "../../Config";

export const PRODUCTS_URL = `${config.url.apiEndPoint}/area_cliente/gd`;

export function fetchHistoricoEconomia(filter) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/historicoEconomia/list`,
    headers: {
      "Content-Type": "application/json"
    },
    data: filter
  }

  return axios(request);
}

export function fetchConsorcios(idCliente) {
  const request = {
    method: "GET",
    url: `${PRODUCTS_URL}/listarConsorcios/${idCliente}`,
    headers: {
      "Content-Type": "application/json"
    },
  }

  return axios(request);
}

export function fetchBigNumbers(filter) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/bigNumbers/obter`,
    headers: {
      "Content-Type": "application/json"
    },
    data: filter
  }

  return axios(request);
}

export function fetchGraficoCompararEconomia(filter) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/graficoCompararEconomia/list`,
    headers: {
      "Content-Type": "application/json"
    },
    data: filter
  }

  return axios(request);
}

export function fetchHistoricoFaturas(filter) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/historicoFaturas/list`,
    headers: {
      "Content-Type": "application/json"
    },
    data: filter
  }

  return axios(request);
}

export function fetchNotificacoesLead(filter) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/notificacoesLead/list`,
    headers: {
      "Content-Type": "application/json"
    },
    data: filter
  }

  return axios(request);
}


export function fetchFaturasDownload(id) {
  const request = {
    method: "POST",
    url: `${PRODUCTS_URL}/exportar/uc-unificada`,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      "idCompensacao": id
    },
    responseType: 'arraybuffer' // Configura a resposta para ser tratada como arraybuffer
  };

  return axios(request);
}